/**
 * Order service API
 *
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Payment } from './payment';
import { BuyerContact } from './buyerContact';
import { OrderPartition } from './orderPartition';
import { SystemComment } from './systemComment';


export interface CreateOrderRequest {
    cartId?: number;
    promocode?: string;
    sumByNegotiation?: number;
    buyerComment?: string;
    negotiationsBySeller?: { [key: string]: number; };
    orderPartitions: Array<OrderPartition>;
    lang: CreateOrderRequest.LangEnum;
    buyerContact?: BuyerContact;
    systemComment?: SystemComment;
    buyerId?: number;
    buyerTypeId?: number;
    payment: Payment;
    buyerType: CreateOrderRequest.BuyerTypeEnum;
    currency: CreateOrderRequest.CurrencyEnum;
    origin?: string;
}
export namespace CreateOrderRequest {
    export type LangEnum = 'RU' | 'EN' | 'HI' | 'FR' | 'AR' | 'KM' | 'ZH';
    export const LangEnum = {
        RU: 'RU' as LangEnum,
        EN: 'EN' as LangEnum,
        HI: 'HI' as LangEnum,
        FR: 'FR' as LangEnum,
        AR: 'AR' as LangEnum,
        KM: 'KM' as LangEnum,
        ZH: 'ZH' as LangEnum
    };
    export type BuyerTypeEnum = 'COMMON_BUYER' | 'COMMON_SELLER' | 'LEGAL_BUYER' | 'LEGAL_SELLER' | 'OPERATOR' | 'COMMON_AGENT' | 'LEGAL_AGENT' | 'UNKNOWN' | 'MODERATOR' | 'TECHNICAL_USER' | 'COURIER';
    export const BuyerTypeEnum = {
        COMMON_BUYER: 'COMMON_BUYER' as BuyerTypeEnum,
        COMMON_SELLER: 'COMMON_SELLER' as BuyerTypeEnum,
        LEGAL_BUYER: 'LEGAL_BUYER' as BuyerTypeEnum,
        LEGAL_SELLER: 'LEGAL_SELLER' as BuyerTypeEnum,
        OPERATOR: 'OPERATOR' as BuyerTypeEnum,
        COMMON_AGENT: 'COMMON_AGENT' as BuyerTypeEnum,
        LEGAL_AGENT: 'LEGAL_AGENT' as BuyerTypeEnum,
        UNKNOWN: 'UNKNOWN' as BuyerTypeEnum,
        MODERATOR: 'MODERATOR' as BuyerTypeEnum,
        TECHNICAL_USER: 'TECHNICAL_USER' as BuyerTypeEnum,
        COURIER: 'COURIER' as BuyerTypeEnum
    };
    export type CurrencyEnum = 'RUB' | 'USD' | 'GEL' | 'KZT' | 'AZN' | 'INR' | 'SAR' | 'TMT' | 'XOF' | 'ZAR' | 'CHF' | 'NGN' | 'EGP' | 'KHR' | 'CNY';
    export const CurrencyEnum = {
        RUB: 'RUB' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        GEL: 'GEL' as CurrencyEnum,
        KZT: 'KZT' as CurrencyEnum,
        AZN: 'AZN' as CurrencyEnum,
        INR: 'INR' as CurrencyEnum,
        SAR: 'SAR' as CurrencyEnum,
        TMT: 'TMT' as CurrencyEnum,
        XOF: 'XOF' as CurrencyEnum,
        ZAR: 'ZAR' as CurrencyEnum,
        CHF: 'CHF' as CurrencyEnum,
        NGN: 'NGN' as CurrencyEnum,
        EGP: 'EGP' as CurrencyEnum,
        KHR: 'KHR' as CurrencyEnum,
        CNY: 'CNY' as CurrencyEnum
    };
}


